export default __webpack_public_path__ + "static/media/superstar.515f0652.svg";